module.exports = __webpack_public_path__ + "media/images/vouchers/sequoia-ec80a40e9d95df2ff1d84801856db009.png";